module.exports = __webpack_public_path__ + "static/img/admin.e147bdeb.png";